import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Navigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const segments = location.pathname.split("/").filter((x) => x);

  const enInicio =
    segments.length === 0 || (segments.length === 1 && segments[0] === "inicio");

  if (enInicio) {
    return null;
  }

  const rutaAnterior =
    segments.length > 1 ? `/${segments.slice(0, -1).join("/")}` : "/inicio";

  return (
    <button
      type="button"
      className="volver-btn"
      onClick={() => navigate(rutaAnterior)}
    >
      ← Volver
    </button>
  );
};

export default Navigation;
